import { render, staticRenderFns } from "./ConnectReferral.vue?vue&type=template&id=0086e003"
import script from "./ConnectReferral.vue?vue&type=script&lang=ts"
export * from "./ConnectReferral.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports